export const handleMensurationFinalProduct = (prev, values, currentStep, callback) => {
	switch(currentStep){
		case "1"		: return validateStep1(prev, values, callback);
		case "2"		: return validateStep2(prev, values, callback);
		case "3"		: return validateStep3(prev, values, callback);
		default 		: return "1" ;
	}
};

function validateStep1(prev, values, callback) {
	if(prev) return "return";

	callback(mapToApi(values), "mensuration");
	return "2";
};

function validateStep2(prev, values, callback) {
	if(prev) return "1";

	callback(mapToApi(values), "mensuration");
	return "3";
};

function validateStep3(prev, values, callback) {
	if(prev) return "2";

	callback(mapToApi(values), "mensuration");
	return "end";
};

function mapToApi(values) {
	return {
		finalProduct: {
			"1"	: values["1"] ? values["1"].products : "",
			"2" : values["2"] || "",
			"3" : {
				jan: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.jan) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.jan_observation : ""
				},
				feb: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.feb) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.feb_observation : ""
				},
				mar: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.mar) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.mar_observation : ""
				},
				apr: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.apr) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.apr_observation : ""
				},
				may: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.may) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.may_observation : ""
				},
				jun: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.jun) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.jun_observation : ""
				},
				jul: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.jul) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.jul_observation : ""
				},
				aug: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.aug) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.aug_observation : ""
				},
				sep: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.sep) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.sep_observation : ""
				},
				oct: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.oct) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.oct_observation : ""
				},
				nov: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.nov) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.nov_observation : ""
				},
				dec: { 
					number: values["3"] ? parseInt(values["3"].quantityProduct.dec) : 0,
					obs		: values["3"] ? values["3"].quantityProduct.dec_observation : ""
				},
			},
		}
	};
};


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/handleMensurationFinalProduct.js